import service from '@/untils/request.js'
import qs from 'qs'
var form = {}

form.formData = ((data, url) => {
    const formData = new FormData()
    for (let key in data) {
        formData.append(key, data[key])
    }

    return service({
        url: url,
        method: 'post',
        data: formData
    })
})

form.bodyrequest = ((url, data) => {
    return service({
        url: url,
        method: 'post',
        data: data
    })
})


form.getrequest = ((url, data, time = 3) => {
    if (data) {
        url += '?' + qs.stringify(data)
    }
    return service({
        url: url,
        method: 'get',
        timeout: time * 1000
    })
})

form.postrequest = ((url, data) => {
    url += '?' + qs.stringify(data)
    return service({
        url: url,
        method: 'post'
    })
})

export default form;